import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import { Container, Jumbo, Tabs, tokens } from '@treams/treams-ui';

import CompetenciesListContainer from '../evaluations/competencies/CompetenciesListContainer';
import CompetencyEditor, { CompetencyCreator } from '../evaluations/competencies/CompetencyEditor';

export default function CompetenciesSettings() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.competencies.title')}
				description={t('settings.competencies.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item
							title={t('settings.competencies.title')}
							path={['/settings/competencies', '/settings/competencies/:id']}
						/>
					</Tabs.Container>
				}
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Switch>
					<Route path={['/settings/competencies/new', '/settings/competencies/new/levels']}>
						<CompetencyCreator />
					</Route>
					<Route path="/settings/competencies/:id">
						{({ match }) => <CompetencyEditor id={match!.params.id!} />}
					</Route>
					<Route>
						<CompetenciesListContainer />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
